import { z } from 'zod'
import { bigDecimalTextSchema } from '../utils/schemas'

export const assetBalanceSchema = z.object({
  amount: bigDecimalTextSchema,
  value: bigDecimalTextSchema,
})

export type AssetBalance = z.infer<typeof assetBalanceSchema>
